import { useEffect } from "react";
import { ProjetoPersonalizadoOffgrid } from "src/components/projetos/personalizados_offgrid";
import { appStore } from "src/framework/store/AppStore";

const PAGE_TITLE = "Projeto personalizado offgrid";

const ProjetosPersonalizadosOffGridPage = () => {
  useEffect(() => {
    appStore.setPageTitle(PAGE_TITLE);
    return () => appStore.setPageTitle("");
  }, []);

  return (
    <div className="container">
      <div className="row">
        <div className="X12">
          <ProjetoPersonalizadoOffgrid />
        </div>
      </div>
    </div>
  );
};

export { ProjetosPersonalizadosOffGridPage };
